class StickyCtaBar extends HTMLElement {
  connectedCallback() {
    this.atcButton = this.querySelector('.sticky-cta-bar__btn--atc');
    this.mainForm = document.querySelector(
      'section[id^="MainProduct-"] product-form[data-sticky-atc-source]'
    );
    this.mainSubmit = this.mainForm
      ? this.mainForm.querySelector('button[type="submit"][name="add"]')
      : null;

    if (!this.mainSubmit) {
      this.classList.add('sticky-cta-bar--no-atc');
      return;
    }

    this.onAtcClick = this.onAtcClick.bind(this);
    this.syncButton = this.syncButton.bind(this);
    this.onErrorShown = this.onErrorShown.bind(this);

    this.syncButton();
    this.atcButton.hidden = false;
    this.classList.add('sticky-cta-bar--with-atc');
    this.atcButton.addEventListener('click', this.onAtcClick);

    this.observer = new MutationObserver(this.syncButton);
    this.observer.observe(this.mainSubmit, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });

    this.errorWrapper = this.mainForm.querySelector('.product-form__error-message-wrapper');
    if (this.errorWrapper) {
      this.errorObserver = new MutationObserver(this.onErrorShown);
      this.errorObserver.observe(this.errorWrapper, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.errorObserver) {
      this.errorObserver.disconnect();
    }
    if (this.atcButton) {
      this.atcButton.removeEventListener('click', this.onAtcClick);
    }
  }

  onErrorShown() {
    if (this.pendingStickyAdd && !this.errorWrapper.hidden) {
      this.pendingStickyAdd = false;
      this.errorWrapper.scrollIntoView({ block: 'center' });
    }
  }

  syncButton() {
    const label = this.mainSubmit.querySelector('span');
    this.atcButton.textContent = (label ? label.textContent : this.mainSubmit.textContent).trim();
    this.atcButton.disabled = this.mainSubmit.disabled;
  }

  onAtcClick(event) {
    event.preventDefault();
    if (this.mainSubmit.disabled) return;
    this.pendingStickyAdd = true;
    this.mainSubmit.click();
  }
}

customElements.define('sticky-cta-bar', StickyCtaBar);
